<div class="p-3">
  @for (a of radioArray; track a) {
    <div class="radio-container w-100 d-flex flex-column" style="margin-bottom: 10px;">
      <div class="w-100">
        <input type="radio" id="a.key" name="fav_language" value="a.name" [checked]="radioArray[0]==a" (click)="feedradioClicked(a.code)">
        <label for="a.key" style="margin-left: 5px;font-weight:bold ;">{{a.name}}</label><br>
      </div>
      <div class="w-100 d-flex flex-row">
        My {{a.heading}} :
        @for (example of a.examples; track example) {
          <a href="javascript:void(0)" (click)="getDetails(a,example)">
            {{example}} ,
          </a>
        }
      </div>
    </div>
  }
  <div class="w-25 d-flex flex-row" style="align-items: flex-end;">
    <div>
      <label for="entercode" style="margin-top: 10px;font-weight:bold ;">{{'field.hint.code' | translate | async }}</label>
      <input type="text" id="entercode" class="form-control" placeholder="Search" (keyup.enter)="getDetails(undefined,search)" [(ngModel)]="search" />
    </div>
    <button class="go-btn btn-success" (click)="getDetails(undefined,search)">Go</button>
  </div>
</div>
@if (_medlineDetails) {
  @for (item of _medlineDetails; track item) {
    <h3 class="pl-3 ml-3">{{item.title._value}}</h3>
    <div [innerHtml]="item.summary._value" class="p-3 m-3 mb-4 box-shadow"></div>
  }
}
<!-- </div> -->